import { ReportEditionState } from 'shared/report';
import { ReportTemplate } from 'shared/report-template/report-template-adapter/model';

import { ReportEditionData } from './report-edition-data.model';

export class ReportEditionDetails {
    reportEditionId: string;
    fromDate: Date;
    toDate: Date;
    publicationDate: Date;
    usedTimeZoneForSite: string;
    template: ReportTemplate;
    data: ReportEditionData;
    state: ReportEditionState;
    canRegenerate: boolean;

    constructor(config: {
        reportEditionId: string;
        fromDate: Date;
        toDate: Date;
        publicationDate: Date;
        usedTimeZoneForSite: string;
        template: ReportTemplate;
        data: ReportEditionData;
        state: ReportEditionState;
        canRegenerate: boolean;
    }) {
        Object.assign(this, config);
    }
}
